import { Helmet } from "react-helmet-async";

/**
 * Per-domain SEO component.
 * `brand` controls default site name, theme color, and social handles.
 */
const BRAND_DEFAULTS = {
  brandify: {
    siteName: "Brandify Official",
    themeColor: "#1cb5ae",
    defaultTitle: "Brandify Official — AI-Powered Marketing Agency",
    defaultDescription:
      "Brandify Official is an AI-powered marketing agency crafting data-driven brand strategy, growth campaigns, and creative systems that scale.",
    twitter: "@brandifyofficial",
  },
  studio: {
    siteName: "Wake N' Bake Studio",
    themeColor: "#F97316",
    defaultTitle: "Wake N' Bake Studio — Creative Production House",
    defaultDescription:
      "Wake N' Bake Studio is a cinematic production house turning brands into unforgettable visual stories—commercials, brand films, and social content.",
    twitter: "@wakenbakestudio",
  },
  unified: {
    siteName: "Brandify x Wake N' Bake Studio",
    themeColor: "#111111",
    defaultTitle: "Brandify x Wake N' Bake Studio",
    defaultDescription:
      "Two studios, one creative engine. Brandify builds AI-powered marketing; Wake N' Bake Studio crafts cinematic brand stories.",
    twitter: "@brandifyofficial",
  },
};

const SEO = ({
  brand = "unified",
  title,
  description,
  image,
  path = "",
  type = "website",
  noIndex = false,
}) => {
  const cfg = BRAND_DEFAULTS[brand] || BRAND_DEFAULTS.unified;
  const pageTitle = title
    ? `${title} — ${cfg.siteName}`
    : cfg.defaultTitle;
  const pageDesc = description || cfg.defaultDescription;
  const origin =
    typeof window !== "undefined" && window.location
      ? window.location.origin
      : "";
  const url = `${origin}${path}`;
  const ogImage = image || `${origin}/og-${brand}.png`;

  return (
    <Helmet>
      <html lang="en" />
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      <meta name="theme-color" content={cfg.themeColor} />
      {noIndex && <meta name="robots" content="noindex,nofollow" />}
      <link rel="canonical" href={url} />

      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={cfg.siteName} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content={cfg.twitter} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDesc} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
